import React from 'react';
import { parseClasses, cleanFieldProps, colorToArray, isColorBright, RGB_2_HEX } from '../../lib/ep.js';
import { useCSS } from '../../lib/hooks.js';

import { SquaredButton } from './ActionButton';
import ButtonCollection from './ButtonCollection';
import FieldWrapper from './FieldWrapper.js';
import Tooltip from './Tooltip.js';

const ColorPickerFromPalette = (props) => {
	useCSS('comp/color_palette.css');

	const value = (props.value) ? props.value : ((props.model != undefined && props.value) ? props.model[props.name] : '');
	
	let palette = props?.palette ?? ['rgba(0, 0, 0, 1)', 'rgba(127, 127, 127, 1)', 'rgba(255, 255, 255, 1)'];

	palette.map((c, i) => {
		const color_rgb = colorToArray(c);
		palette[i] = `rgba(${color_rgb.join(", ")}, 1)`;
	});

	const enable_random = props?.enable_random ?? false;
	const enable_empty = props?.enable_empty ?? false;

	const change = (value) => {
		if(props.change != undefined) props.change(props.name, value);
	};

	const wrapper_props = cleanFieldProps(props);
	
	let classname = props?.classname ?? 'input textarea';
	classname = parseClasses(classname, props._class, 'colorpalette');

	return (
		<>
			<FieldWrapper type='colorpalette' {...wrapper_props}>
				<div>
					<ButtonCollection
						_class={{ other:'gui_color_palette' }}
						style={{ minHeight:'34px' }}
					>
						{(enable_random) && (
							<SquaredButton
								icon='knk-ball-drum is_random customButton'
								onClick={() => change('random')}
								_class={(value == 'random') ? { other:'selected' } : null}
								tooltip={<Tooltip
									with_icon={false}
									position='top'
								>Pick a random color among the available set</Tooltip>}
							/>
						)}

						{palette.map((color) => {
							const selected = (color == value) ? true : false;

							const color_rgb = colorToArray(color);
							const is_color_bright = (isColorBright(RGB_2_HEX(color))) ? true : false;

							return (
								<SquaredButton
									key={color}
									icon={`customButton ${(is_color_bright) ? 'blackIcon' : 'whiteIcon'}`}
									onClick={() => change(color)}
									_class={(selected) ? { other:'ep-on selected' } : null}
									style={{ '--btn-bg-color':`${color_rgb.join(", ")}` }}
								/>
							)
						})}

						{(enable_empty) && (
							<SquaredButton
								icon='knk-blocked is_random customButton'
								onClick={() => change('no')}
								_class={(value == 'no') ? { other:'selected' } : null}
								tooltip={<Tooltip
									with_icon={false}
									position='top'
								>Discard</Tooltip>}
							/>
						)}
					</ButtonCollection>
				</div>
			</FieldWrapper>
		</>
	);
};

export default ColorPickerFromPalette;